import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const ChatHeader = () => {
  const history = useHistory();

  const handleGoBack = () => {
    history.goBack();
  };

  let DefaultAvatar_2 = "https://cdn-icons-png.flaticon.com/512/21/21104.png";

  const name = "Admin";

  return (
    <div className="d-flex bg-primary p-2 align-items-center rounded-lg ">
      <i
        role="button"
        onClick={handleGoBack}
        class="fas fa-chevron-left text-white fa-1x mr-3 ml-3"
      ></i>

      <div className="flex flex-col">
        <h5 className="m-0 mx-2 fs--20 fw--700 ml-3 text-white">{name}</h5>
      </div>
    </div>
  );
};

export default ChatHeader;
